import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Link } from 'react-router-dom'
import { Queries, Mutations } from '../../../../graphql'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, Radio, DatePicker, Avatar, Modal, InputNumber } from 'antd'
import FromInput from '../../../../components/user/from/Input'
import Container from '../../../../components/user/Container'
import IframeFile from '../../../../components/user/IframeFile'
import ImageFileNewtab from '../../../../components/user/ImageFileNewtab'
import TalbePeople from '../../../../components/user/Hospital/TalbePeople'
import TableSummary from '../../../../components/user/Hospital/TableSummary'
import { checkDisbledInput, setSummaryTotal, checkStatus, setSummarySlipWithdrawTotal } from '../../../../utils/hospital'
import { numberWithCommas } from '../../../../utils/number'
import { changeFormatdate, changeFormatFulldate } from '../../../../utils/formatdate'
import moment from 'moment'
import ModalConfirmForm from '../../../../components/user/ModalConfirmForm'
import ModalshowAllImage from '../../../../components/user/ModalshowAllImage'
import TableMedicalCertificate from '../../../../components/user/Hospital/TableMedicalCertificate/Update'
import { alertMessage } from '../../../../utils/message'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;
const { TextArea } = Input;

const newsDataProfile = '';
const DOCUMENT_TYPE = [
    { label: 'ใบรับรองแพทย์', value: 'ใบรับรองแพทย์' },
    { label: 'ใบสูติบัตร', value: 'ใบสูติบัตร' },
    { label: 'อื่น ๆ', value: 'อื่น ๆ' },
]

class Withdraw extends Component {
	state = {
		loading:false,
        detailForm:[],
		dataTalbeUploads: [],
        columns: [
            {
                title: 'เล่ม',
                dataIndex: 'slipNo',
                width:'100',
				align:'center',
                vertical:'top',
                render: (item, record, index) => {
                    return(
                        <>
                            {
                                !record.rowSummary &&
                                <Form.Item label={""}>
                                    { this.props.form.getFieldDecorator("slipNo"+index, {
                                        initialValue: item,
                                        rules:  [{ 
                                            required: true, 
                                            message: 'กรุณากรอกเล่ม',
                                        }],
                                    })(
                                        <Input 
                                            // defaultValue={item} 
                                            // disabled={ record.wdSlipId ? checkDisbledInput(record.status, "slipNo") ? true : false : false }
                                            disabled={true}
                                            onBlur={ (e) => this.onChangeValueForm(index, e, 'slipNo') }
                                        />
                                    )}
                                </Form.Item>
                            }
                            
                        </>
                    )
                }
            },
            {
                title: ()=>{
                    return <span>เลขที่ใบเสร็จ <span class="color-red">*</span></span>
                },
                dataIndex: 'numberSlip',
                vertical:'top',
				align:'center',
                width:'100',
                render: (item, record, index) => {
                    return(
                        <>
                            {
                               !record.rowSummary &&
                                <Form.Item label={""}>
                                    { this.props.form.getFieldDecorator("numberSlip"+index, {
                                        initialValue: item,
                                        rules:  [{ 
                                            required: true, 
                                            message: 'กรุณาระบุ เลขที่ใบเสร็จ',
                                        }],
                                    })(
                                        <Input 
                                            // defaultValue={item} 
                                            // disabled={ record.wdSlipId ? checkDisbledInput(record.status, "numberSlip") ? true : false : false }
                                            disabled={true}
                                            onBlur={ (e) => this.onChangeValueForm(index, e, 'numberSlip') }
                                        />
                                    )}
                                </Form.Item>
                            }
                        </>
                    )
                }
            },
			{
                title: ()=>{
                    return <span>วันที่ใบเสร็จ <span class="color-red">*</span></span>
                },
                dataIndex: 'date',
				align:'center',
                vertical:'top',
                width:'190',
                render: (item, record, index) => {
                    return(
                        <>
                            {
                                !record.rowSummary &&
                                <Form.Item label={""}>
                                    { this.props.form.getFieldDecorator("date"+index, {
                                        initialValue: item ? moment(item) : '',
                                        rules:  [{ 
                                            required: true, 
                                            message: 'กรุณาระบุ วันที่ใบเสร็จ',
                                        }],
                                    })(
                                        <DatePicker 
                                            // defaultValue={ item ? moment(item) : '' } 
                                            format={this.dateFormatNumber("date"+index)} 
                                            // disabled={ record.wdSlipId ? checkDisbledInput(record.status, "dateTable") ? true : false : false }
                                            disabled={true}
                                            placeholder="เลือกวันที่"
                                            onChange={ (e) => this.onChangeValueForm(index, e, 'date') }
                                        />
                                    )}
                                </Form.Item>
                            }
                        </>
                    )
                }
            },
			{
                title: ()=>{
                    return <span>จำนวนเงินในใบเสร็จ <span class="color-red">*</span></span>
                },
				align:'center',
                width:'150',
                vertical:'top',
                dataIndex: 'totalPrice',
                render: (item, record, index) => {
                    return(
                        <>
                            {
                                record.rowSummary ?
                                    <Input 
                                        value={ numberWithCommas(this.state.summaryTotalTable) }
                                        className='block-news' 
                                        disabled={true}
                                        className="input-number"
                                    />
                                :
                                <Form.Item label={""}>
                                    { this.props.form.getFieldDecorator("totalPrice"+index, {
                                        initialValue: item,
                                        getValueFromEvent: value =>{
                                            return value && value !== '0' && value !== '-' ? value : ''
                                        },
                                        rules:  [{ 
                                            required: true, 
                                            message: 'กรุณาระบุ จำนวนเงินในใบเสร็จ',
                                        }],
                                    })(
                                        // <Input 
                                        //     // defaultValue={item}
                                        //     // step={1000.000}
                                        //     disabled={ record.wdSlipId ? checkDisbledInput(record.status, "totalPrice") ? true : false : false }
                                        //     onBlur={ (e) => this.onChangeValueForm(index, e, 'totalPrice') }
                                        // />
                                        <InputNumber 
                                            // defaultValue={item}
                                            step={1000.01}
                                            min={0.00}
                                            // disabled={ record.wdSlipId ? checkDisbledInput(record.status, "totalPrice") ? true : false : false }
                                            disabled={true}
                                            formatter={item => `${item}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={item => item.replace(/\$\s?|(,*)/g, '')}
                                            onBlur={ (e) => this.onChangeValueForm(index, e, 'totalPrice') }
                                            className="input-number"
                                        />
                                    )}
                                </Form.Item>
                            }
                        </>
                       
                    )
                }
            },
            {
                title: ()=>{
                    return <span>จำนวนเงินที่เบิกได้ <span class="color-red">*</span></span>
                },
				align:'center',
                width:'150',
                vertical:'top',
                dataIndex: 'totalSlipWithdraw',
                render: (item, record, index) => {
                    return(
                        <>
                            {
                                record.rowSummary ?
                                    <Input 
                                        value={ numberWithCommas(this.state.summaryTotalTableSlipWithdraw) }
                                        className='block-news' 
                                        disabled={true}
                                        className="input-number"
                                    />
                                :
                                    <Form.Item label={""}>
                                        { this.props.form.getFieldDecorator("totalSlipWithdraw"+index, {
                                            initialValue: item,
                                            getValueFromEvent: value =>{
                                                return value && value !== '0' && value !== '-' ? value : ''
                                            },
                                            rules:  [{ 
                                                required: true, 
                                                message: 'กรุณาระบุ จำนวนเงินในใบเสร็จ',
                                            }],
                                        })(
                                            // <Input 
                                            //     // defaultValue={item}
                                            //     // step={1000.000}
                                            //     disabled={ record.wdSlipId ? checkDisbledInput(record.status, "totalSlipWithdraw") ? true : false : false }
                                            //     onBlur={ (e) => this.onChangeValueForm(index, e, 'totalSlipWithdraw') }
                                            // />
                                            <InputNumber 
                                                // defaultValue={item}
                                                step={1000.01}
                                                min={0.00}
                                                // disabled={ record.wdSlipId ? checkDisbledInput(record.status, "totalSlipWithdraw") ? true : false : false }
                                                disabled={true}
                                                formatter={item => `${item}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={item => item.replace(/\$\s?|(,*)/g, '')}
                                                onBlur={ (e) => this.onChangeValueForm(index, e, 'totalSlipWithdraw') }
                                                className="input-number"
                                            />
                                        )}
                                    </Form.Item>
                                }
                        </>
                       
                    )
                }
            },
            {
                title: ()=>{
                    return <span>เอกสารแนบ <span class="color-red">*</span></span>
                },
                dataIndex: '7',
                width:'200',
                vertical:'top',
				align:'center',
                render: (item, record, index) => {
                    return (
                        <>
                            { this.showMoreFileUploads(index, 'Images') }
                           {/* { this.inputFormUploads(index) } */}
                        </>
                    )
                }
            },
            {
                title: 'จัดการ',
                dataIndex: '7',
                width:'20',
                vertical:'top',
				align:'center',
                fixed:'right',
                render: (item, record, index) => {
                    return <>
                                {
                                    !record.rowSummary &&
                                        this.showDetailBtnInput(record, index)
                                }
                            </>
                }
            },
        ],
        dataTalbeLength:1,
		pageData: {
            offset: 0,
            limit: 10
        },
        pagination: {
            total: 10,
        },
        summaryTotal: 0,
        summaryTotalTable: 0,
        checkMoney:1,
        preLoadOnsubmit: false,
        detailProfile:null,
        relationValue:null,
        ageValue:null,
        withdrawFirstName:null,
        withdrawLastName:null,
        withdrawIdCard:null,
        listFamily:[],
        dropdownFamily:[],
        dropdownApproverMedical:[],
        dropdownHospital:[],
        hospitalDetailValue:null,
        dropdownSickness:[],
        visibleModal:false,
        modalFileMimeType: null,
        modalFileId:null,
        dataTalbePeople: [],
        dataTalbeUploadsDocument: [],
        columnsDocument: [
            {
                title: 'ประเภทเอกสารแนบ',
                dataIndex: 'documentType',
				align:'center',
                vertical:'top',
                render: (item, record, index) => {
                    return(
                        <>
                            <Form.Item label={""}>
                                { this.props.form.getFieldDecorator("documentType"+index, {
                                    initialValue: item,
                                    rules:  [{ 
                                        required: record.description ? true : false,
                                        message: 'กรุณาเลือกประเภทเอกสาร',
                                    }],
                                })(
                                    <Select 
                                        style={{ width: "100%" }}
                                        onChange={ (e) => this.onChangeValueFormDocument(index, e, 'documentType') }
                                        showSearch
                                        placeholder="กรุณาเลือก"
                                        optionFilterProp="children"
                                        // disabled={ this.checkDisbledInputDocument(record) }
                                        disabled={true}
                                    >
                                        {
                                            DOCUMENT_TYPE.map((valuesLabel, keys)=>{
                                                return <Option value={valuesLabel.value}>{ valuesLabel.label }</Option>
                                            })
                                        }
                                    </Select>
                                )}
                            </Form.Item>
                        </>
                    )
                }
            },
            {
                title: 'รายละเอียดเพิ่มเติม',
                dataIndex: 'description',
                vertical:'top',
				align:'center',
                render: (item, record, index) => {
                    return(
                        <>
                            <Form.Item label={""}>
                                { this.props.form.getFieldDecorator("description"+index, {
                                    initialValue: item,
                                    rules:  [{ 
                                        required: record.statusFile ? true : false, 
                                        message: 'กรุณากรอกรายละเอียด',
                                    }],
                                })(
                                    <Input 
                                        // defaultValue={item} 
                                        // disabled={ this.checkDisbledInputDocument(record) }
                                        disabled={true}
                                        onBlur={ (e) => this.onChangeValueFormDocument(index, e, 'description') }
                                    />
                                )}
                            </Form.Item>
                        </>
                    )
                }
            },
            {
                title: 'เอกสารแนบ',
                dataIndex: '7',
                width:'200',
                vertical:'top',
				align:'center',
                render: (item, record, index) => {
                    return (
                        <>
                            { this.showMoreFileUploads(index, 'Doc') }
                           {/* { this.inputFormUploadsDocument(index) } */}
                        </>
                    )
                }
            },
            {
                title: 'จัดการ',
                dataIndex: '7',
                width:'20',
                vertical:'top',
				align:'center',
                render: (item, record, index) => {
                    return this.showDetailBtnInputDocument(record, index)
                }
            },
        ],
        dataTalbeLengthDocument:1,
		pageDataDocument: {
            offset: 0,
            limit: 10
        },
        paginationDocument: {
            total: 10,
        },
        ModalshowAllImageVisible: false,
        ModalshowAllImageTitle:null,
        ModalshowAllImageData:[],
        ModalshowAllImageArrayId:null,
        ModalshowAllImageDatabase: false
	}

    dateFormatNumber = (values) =>{
        let valueReturn = this.props.form.getFieldValue(values)
        return changeFormatdate(moment(valueReturn))
    }

    destroyArrayDataImages =  async (arrayId, arraySpliceFileName) =>{
        const { dataTalbeUploads, ModalTypeUpload } = this.state
        let indexKey = null

        if(ModalTypeUpload == 'Images'){
            var arrayDataSource = [...this.state.dataTalbeUploads];
            arrayDataSource[arrayId].file.map(( values, keys ) =>{
                if(values.name == arraySpliceFileName){
                    indexKey = keys
                }
            })
            
            arrayDataSource[arrayId].file.splice(indexKey, 1);
            
            await this.setState({
                dataTalbeUploads:arrayDataSource,
                // ModalshowAllImageData: arrayDataSource[arrayId].file
            },async() => {
                if(arrayDataSource[arrayId].file.length == 0) {
                    await this.setState({
                        ModalshowAllImageVisible: false
                    })
                }
            })
        }else if(ModalTypeUpload == 'Doc'){
            var arrayDataSource = [...this.state.dataTalbeUploadsDocument];
            arrayDataSource[arrayId].file.map(( values, keys ) =>{
                if(values.name == arraySpliceFileName){
                    indexKey = keys
                }
            })
            
            arrayDataSource[arrayId].file.splice(indexKey, 1);
            
            await this.setState({
                dataTalbeUploadsDocument:arrayDataSource,
                // ModalshowAllImageData: arrayDataSource[arrayId].file
            },async() => {
                if(arrayDataSource[arrayId].file.length == 0) {
                    await this.setState({
                        ModalshowAllImageVisible: false
                    })
                }
            })
        }
    }

    ModalshowAllImageShow = async (data, title, arrayId, imageDatabase, modalTypeUpload)=>{
        await this.setState({
            ModalshowAllImageVisible: true,
            ModalshowAllImageTitle: title,
            ModalshowAllImageData: data,
            ModalshowAllImageArrayId: arrayId,
            ModalshowAllImageDatabase: imageDatabase,
            ModalTypeUpload : modalTypeUpload
        })
    }

    ModalshowAllImageHide = async () =>{
        await this.setState({
            ModalshowAllImageVisible: false,
            ModalshowAllImageTitle: null,
            ModalshowAllImageData: [],
            ModalshowAllImageArrayId: null,
            ModalshowAllImageDatabase: false
        })
    }

    showMoreFileUploads = (arrayId, uploadFile) =>{
        const { dataTalbeUploads, dataTalbeUploadsDocument } = this.state
        let fileName = null
        let fileNameShow = null

        if(uploadFile == 'Images'){
            if(dataTalbeUploads[arrayId].wdSlipId){
                return <>
                            <p 
                                onClick={ () => { this.ModalshowAllImageShow(dataTalbeUploads[arrayId].fileData, 'ไฟล์อัปโหลดเอกสารแนบใบเสร็จ', arrayId, true, uploadFile) }} 
                                style={{ cursor:"pointer" }}
                                className="btn-show-fileuploads"
                            >
                                ดูไฟล์อัปโหลด
                            </p>
                        </>
            }else if(dataTalbeUploads[arrayId].rowSummary){
                return ''
            }else if(dataTalbeUploads[arrayId].file.length !== 0){
                return  <>
                            <p 
                                onClick={ () => { this.ModalshowAllImageShow(dataTalbeUploads[arrayId].file, 'ไฟล์อัปโหลดเอกสารแนบใบเสร็จ', arrayId, false, uploadFile) }} 
                                style={{ cursor:"pointer" }}
                                className="btn-show-fileuploads"
                            >
                                ดูไฟล์อัปโหลด
                            </p>
                        </>
            }else{
                return <span className={ fileName ? '' : "color-red"  }>กรุณาเลือกอัปโหลดรูปภาพหรือไฟล์</span>
            }
        }else if(uploadFile == 'Doc'){
            if(dataTalbeUploadsDocument[arrayId].wdHospitalDocumentId){
                return <>
                            {
                                dataTalbeUploadsDocument[arrayId].fileData.length !== 0 &&
                                    <p 
                                        onClick={ () => { this.ModalshowAllImageShow(dataTalbeUploadsDocument[arrayId].fileData, 'ไฟล์อัปโหลดเอกสารแนบอื่นๆ', arrayId, true, uploadFile) }} 
                                        style={{ cursor:"pointer" }}
                                        className="btn-show-fileuploads"
                                    >
                                        ดูไฟล์อัปโหลด
                                    </p>
                                ||
                                    ''
                            }
                            {/* <p 
                                onClick={ () => { this.ModalshowAllImageShow(dataTalbeUploadsDocument[arrayId].fileData, 'ไฟล์อัปโหลดเอกสารแนบอื่นๆ', arrayId, true, uploadFile) }} 
                                style={{ cursor:"pointer" }}
                                className="btn-show-fileuploads"
                            >
                                ดูไฟล์อัปโหลด
                            </p> */}
                        </>
            }else if(dataTalbeUploadsDocument[arrayId].file.length !== 0){
                return  <>
                            <p 
                                onClick={ () => { this.ModalshowAllImageShow(dataTalbeUploadsDocument[arrayId].file, 'ไฟล์อัปโหลดเอกสารแนบอื่นๆ', arrayId, false, uploadFile) }} 
                                style={{ cursor:"pointer" }}
                                className="btn-show-fileuploads"
                            >
                                ดูไฟล์อัปโหลด
                            </p>
                        </>
            }else{
                return <span className={ fileName ? '' : "color-red"  }>กรุณาเลือกอัปโหลดรูปภาพหรือไฟล์</span>
            }
        }
        
    }

    inputFormUploads = (arrayId) =>{
        const { dataTalbeUploads } = this.state
        return(
            <>
                {
                    dataTalbeUploads[arrayId].wdSlipId ? 
                        <>
                             {/* <Text 
                                onClick={ () => { this.modalShowFile(dataTalbeUploads[arrayId].fileData) }} 
                                style={{ cursor:"pointer" }}
                            >
                                ดูไฟล์อัปโหลด
                            </Text>
                            <br></br> */}
                        </>
                    :
                        <>
                            <label for={"input-file-"+arrayId} class="custom-file-upload">
                                <p className="py-2 px-4" align={"center"} style={{ backgroundColor:"#8d0e14", color:"#fff" }}>
                                    {/* อัปโหลด */}
                                    อัปโหลด +
                                </p>
                                <p style={{ fontSize:"12px" }} className="my-2">แนบไฟล์ที่เป็นนามสกุล<br></br> .jpg, .png หรือ .pdf</p>
                            </label>
                            <input
                                id={"input-file-"+arrayId}
                                className="input-file"
                                multiple
                                // name={uploadName}
                                type="file"
                                accept="file_extension"
                                // rules={ true }
                                onChange={e => this.handleAdd(e.target.files,arrayId)}
                                // onChange={e => console.log(e.target.files)}
                            />
                        </>
                }
            </>
        )
    }

    showDetailBtnInputDocument = (record, arrayId) =>{
        const { dataTalbeUploadsDocument, detailForm } = this.state
        return(
            <>
                <Avatar 
                    disabled={true}
                    shape="square"  
                    icon={<Icon type="delete" />} 
                    className="mr-1 mb-1"  
                    style={{ cursor: 'not-allowed' }}
                />
                {/* {
                    (detailForm.status == 'MOREINFO' || detailForm.status == 'DRAFT' ) &&
                        <>
                            {
                                dataTalbeUploadsDocument.length > 1 ? 
                                    <>
                                        {
                                            record.wdHospitalDocumentId ?
                                                <Popconfirm
                                                    placement="topRight"
                                                    title={"คุณต้องการที่จะลบไฟล์"}
                                                    onConfirm= { () => this.deleteAttachmentFile(dataTalbeUploadsDocument[arrayId].wdHospitalDocumentId, arrayId) }
                                                    okText="ตกลง"
                                                    cancelText="ยกเลิก"
                                                >
                                                    <Avatar 
                                                        disabled={true}
                                                        shape="square"  
                                                        icon={<Icon type="delete" />} 
                                                        className="mr-1 mb-1 bg-red"  
                                                        style={{ cursor: 'pointer', background:"red" }}
                                                    />
                                                </Popconfirm>
                                                :  
                                                    <Avatar 
                                                        disabled={true}
                                                        shape="square"  
                                                        icon={<Icon type="delete" />} 
                                                        className="mr-1 mb-1 bg-red"  
                                                        onClick={ () => this.destroyArrayDataUploadsDocument(arrayId) }
                                                        style={{ cursor: 'pointer', background:"red" }}
                                                    />
                                            }
                                    </>
                                        
                                : 
                                    <>
                                        {
                                            record.wdHospitalDocumentId ?
                                                <Avatar 
                                                    disabled={true}
                                                    shape="square"  
                                                    icon={<Icon type="delete" />} 
                                                    className="mr-1 mb-1 bg-red"  
                                                    style={{ cursor: 'not-allowed' }}
                                                />
                                            :
                                                <Avatar 
                                                    disabled={true}
                                                    shape="square"  
                                                    icon={<Icon type="delete" />} 
                                                    className="mr-1 mb-1 bg-red"  
                                                    onClick={ () => this.destroyArrayDataUploadsDocument(arrayId) }
                                                    style={{ cursor: 'not-allowed' }}
                                                />
                                        }
                                    </>
                            }
                        </>
                    || 
                        <>
                            <Avatar 
                                disabled={true}
                                shape="square"  
                                icon={<Icon type="delete" />} 
                                className="mr-1 mb-1 bg-red"  
                                style={{ cursor: 'not-allowed' }}
                            />
                        </>
                } */}
            </>
        )
    }

    deleteAttachmentFile = async (wdHospitalDocumentId, arrayId) =>{
        const { form, afterSubmit, client, match } = this.props
        try {
            const { data, errors } = await client.mutate({
                mutation: Mutations.destroyWDHospitalDocument,
                variables: {
                    wdHospitalDocumentId,
                }
            })

            if(data){
                alertMessage("success","ส่งเพื่อดำเนินการเรียบร้อย")
                // message.success("ส่งเพื่อดำเนินการเรียบร้อย")
                await this.destroyArrayDataUploadsDocument(arrayId)
                // setTimeout(() => {
                //     window.location.reload();
                // }, 600);
            }
        }catch (error) {
            
        }
    }

    checkDisbledInputDocument = (record) =>{
        const { dataTalbeUploadsDocument, detailForm } = this.state

        if(detailForm.status == 'MOREINFO' || detailForm.status == 'DRAFT'){
            return record.wdHospitalDocumentId ? checkDisbledInput(record.status, "descriptionForm") ? true : false : false 
        }else{
            return true
        }
        // return
    }

    onChangeValueFormDocument = async (arrayId, values, name) =>{
        const { dataTalbeUploadsDocument } = this.state
        let dataSourceitems = [...this.state.dataTalbeUploadsDocument];
        let item = {...dataSourceitems[arrayId]};

        if(name == 'description'){
            console.log('vavaluesvalueslues',values.target.value)
            item.description = values.target.value
        }else if(name == 'documentType'){
            console.log('documentType',values)
            item.documentType = values
            item.statusFile = values == 'อื่น ๆ' ? true : false
        }

        dataSourceitems[arrayId] = item;

        // console.log('dataSourceitems',dataSourceitems)

        await this.setState({
            dataTalbeUploadsDocument:dataSourceitems
        },async () => {
            // await this.setSummary()
			// this.cllBackSetValueContactNumber()
        })
    }
   
    destroyArrayDataUploadsDocument =  async (arrayId) =>{
        const { dataTalbeUploadsDocument } = this.state
        var arrayDataSource = [...this.state.dataTalbeUploadsDocument];
		arrayDataSource.splice(arrayId, 1);

		await this.setState({
			dataTalbeUploadsDocument:arrayDataSource,
            // dataTalbeLength: lengthData
		},async() => {
            let lengthData = arrayDataSource.length;
            await this.setState({
                dataTalbeLengthDocument: lengthData
            })

            arrayDataSource.map(async (valuesTable, keysTable) =>{
                let documentType = `documentType${keysTable}`
                let description = `description${keysTable}`
                // "documentType"+index
                await this.props.form.setFieldsValue({
                    [documentType]: valuesTable.documentType,
                    [description]: valuesTable.description,
                })
            })
		})
    }

    showDataInputUploadsDocument = async () =>{
        const { dataTalbeUploadsDocument, reqAttachDayStatus } = this.state
        const rows = {
            wdHospitalDocumentId: null,
            documentType: null,
            statusFile: false,
            description: null,
            attachFile: null,
        }
        await this.setState(prevState => ({
            dataTalbeUploadsDocument: [...prevState.dataTalbeUploadsDocument, rows],
        }), async () => {
            let lengthData = dataTalbeUploadsDocument.length+1;
            await this.setState({
                dataTalbeLengthDocument: lengthData
            })
        })
    }

    handleAddDocument = async (images, arrayId ) => {
        const { dataTalbeUploadsDocument, reqAttachDayStatus } = this.state
        console.log('imagesimagesimages',images)
        if(images){
            const isLt2M = images.size / 1024 / 1024 < 1;
			if (!isLt2M) {
                alertMessage("error","ไฟล์ขนาดใหญ่เกิน 1MB กรุณาเลือกไฟล์ใหม่อีกครั้ง")
				// message.error('ไฟล์ขนาดใหญ่เกิน 1MB กรุณาเลือกไฟล์ใหม่อีกครั้ง');
                let dataSourceitems = [...this.state.dataTalbeUploadsDocument];
                let item = {...dataTalbeUploadsDocument[arrayId]};
                item = {
                    wdHospitalDocumentId: null,
                    documentType: item.documentType,
                    statusFile: item.documentType == 'อื่น ๆ' ? true : false,
                    description: item.description,
                    attachFile: null,
                }
                dataSourceitems[arrayId] = item;
    
                await this.setState(({
                    dataTalbeUploadsDocument: dataSourceitems,
                }), () => {
                    // this.cllBackSetValueOrganizatuions()
                })
			}else{
                let dataSourceitems = [...this.state.dataTalbeUploadsDocument];
                let item = {...dataTalbeUploadsDocument[arrayId]};
                item = {
                    wdHospitalDocumentId: null,
                    documentType: item.documentType,
                    statusFile: item.documentType == 'อื่น ๆ' ? true : false,
                    description: item.description,
                    attachFile: images,
                }
                dataSourceitems[arrayId] = item;
    
                await this.setState(({
                    dataTalbeUploadsDocument: dataSourceitems,
                }), () => {
                    // this.cllBackSetValueOrganizatuions()
                })
			}
         alertMessage("กรุณาแนบไฟล์ที่เป็นนามสกุล .jpg, .png หรือ .pdf")
        }
	}

    inputFormUploadsDocument = (arrayId) =>{
        const { dataTalbeUploadsDocument } = this.state
        let fileName = dataTalbeUploadsDocument[arrayId].attachFile ? dataTalbeUploadsDocument[arrayId].attachFile.name : ""
        let fileNameShow = fileName.length <= 10 ? fileName : fileName.slice(0,10)+'...'+fileName.slice(-4) 
        return(
            <>
                {
                    dataTalbeUploadsDocument[arrayId].wdHospitalDocumentId ? 
                        <>
                            {
                                dataTalbeUploadsDocument[arrayId].fileData &&
                                    <>
                                        <Text 
                                            onClick={ () => { this.modalShowFile(dataTalbeUploadsDocument[arrayId].fileData, 'เอกสารแนบ') }} 
                                            style={{ cursor:"pointer" }}
                                            className="btn-show-fileuploads"
                                        >
                                            ดูไฟล์อัปโหลด
                                        </Text>
                                        <br></br>
                                    </>
                                ||
                                    <>
                                        <Text>
                                            -
                                        </Text>
                                    </>
                            }
                        </>
                    :
                        <>
                            <label for={"input-fileDocument-"+arrayId} class="custom-file-upload">
                                <p className="py-2 px-4" align={"center"} style={{ backgroundColor:"#8d0e14", color:"#fff" }}>
                                    อัปโหลด
                                </p>
                                <p style={{ fontSize:"12px" }} className="my-2">แนบไฟล์ที่เป็นนามสกุล<br></br> .jpg, .png หรือ .pdf</p>
                            </label>
                            <span className={ fileName ? '' : "color-red"  }>
                                { 
                                    fileName ? 
                                    <Text 
                                        onClick={ () => { this.modalShowFileCreate(dataTalbeUploadsDocument[arrayId].attachFile, 'เอกสาร') }} 
                                        style={{ cursor:"pointer" }}
                                        className="btn-show-fileuploads"
                                    >
                                        {/* {fileNameShow} */}
                                        ดูไฟล์อัปโหลด
                                    </Text>
                                    :
                                    "กรุณาเลือกอัปโหลดรูปภาพหรือไฟล์"  
                                }
                            </span>
                            <input
                                id={"input-fileDocument-"+arrayId}
                                className="input-file"
                                // name={uploadName}
                                type="file"
                                accept="file_extension"
                                // rules={ true }
                                onChange={e => this.handleAddDocument(e.target.files[0],arrayId)}
                            />
                        </>
                }
            </>
        )
    }

    fetchMedicalExpensesLicensee = async () =>{
        const { client, location, match } = this.props
        const { posId } = this.state
        const { data, errors } = await client.query({
            query: Queries.fetchMedicalExpensesLicensee,
        })

        // console.log('data',data)
        if(data.fetchMedicalExpensesLicensee){
            await this.setState({
                listFamily: data.fetchMedicalExpensesLicensee
            })
        }
    }

    dropdownMedicalExpensesLicensee = async () =>{
        const { client, location, match } = this.props
        const { posId } = this.state
        const { data, errors } = await client.query({
            query: Queries.dropdownMedicalExpensesLicensee,
        })

        // console.log('data',data)
        if(data.dropdownMedicalExpensesLicensee){
            await this.setState({
                dropdownFamily: data.dropdownMedicalExpensesLicensee
            })
        }
    }

    fetchApproverMedical = async () =>{
        const { client, location, match } = this.props
        const { posId } = this.state
        const { data, errors } = await client.query({
            query: Queries.fetchApproverMedical,
        })

        if(data.fetchApproverMedical){
            await this.setState({
                dropdownApproverMedical: data.fetchApproverMedical
            })
        }
    }

    fetchProfile = async () => {
        const { client, location, match } = this.props
        const { posId } = this.state
        const { data, errors } = await client.query({
            query: Queries.fetchProfile,
        })
        // console.log()
        await this.setState({
            detailProfile: data.fetchProfile
        })
    }

    showDetailBtnInput = (record, arrayId) =>{
        const { dataTalbeLength, dataTalbeUploads, detailForm } = this.state
        return(
            <>
                <Avatar 
                    disabled={true}
                    shape="square"  
                    icon={<Icon type="delete" />} 
                    className="mr-1 mb-1 bg-red"  
                    style={{ cursor: 'not-allowed' }}
                />
                {/* {
                    (detailForm.status == 'MOREINFO' || detailForm.status == 'DRAFT' ) &&
                    <>
                        {
                            dataTalbeUploads.length > 1 ? 
                                    <>
                                        {
                                            record.wdSlipId ?
                                                <Popconfirm
                                                    disabled={true}
                                                    placement="topRight"
                                                    title={"คุณต้องการที่จะลบไฟล์"}
                                                    onConfirm= { () => this.destroyWDSlip(dataTalbeUploads[arrayId].wdSlipId, arrayId) }
                                                    okText="ตกลง"
                                                    cancelText="ยกเลิก"
                                                >
                                                    <Avatar 
                                                        shape="square"  
                                                        icon={<Icon type="delete" />} 
                                                        className="mr-1 mb-1 bg-red"  
                                                        style={{ cursor: 'no-drop' }}
                                                        // style={{ cursor: 'pointer', background:"red" }}
                                                    />
                                                </Popconfirm>
                                            :
                                                <Avatar 
                                                    shape="square"  
                                                    icon={<Icon type="delete" />} 
                                                    className="mr-1 mb-1 bg-red"  
                                                    onClick={ () => this.destroyArrayDataUploads(arrayId) }
                                                    style={{ cursor: 'pointer', background:"red" }}
                                                />
                                        }
                                    </>
                            : 
                                <>
                                    {
                                        record.wdSlipId ?
                                            <Avatar 
                                                disabled={true}
                                                shape="square"  
                                                icon={<Icon type="delete" />} 
                                                className="mr-1 mb-1 bg-red"  
                                                style={{ cursor: 'not-allowed' }}
                                            />
                                        :
                                            <Avatar 
                                                disabled={true}
                                                shape="square"  
                                                icon={<Icon type="delete" />} 
                                                className="mr-1 mb-1 bg-red"  
                                                // onClick={ () => this.destroyArrayDataUploads(arrayId) }
                                                style={{ cursor: 'not-allowed' }}
                                            />
                                    }
                                </>
                        }
                    </>
                    || 
                        <>
                            <Avatar 
                                disabled={true}
                                shape="square"  
                                icon={<Icon type="delete" />} 
                                className="mr-1 mb-1 bg-red"  
                                style={{ cursor: 'not-allowed' }}
                            />
                        </>
                } */}
            </>
        )
    }

    onChangeValueForm = (arrayId, values, name) =>{
        const { dataTalbeUploads } = this.state
        let dataSourceitems = [...this.state.dataTalbeUploads];
        let item = {...dataSourceitems[arrayId]};

        console.log(values)
        if(name == 'slipNo'){
            item.slipNo = values.target.value
        }else if(name == 'numberSlip'){
            item.numberSlip = values.target.value
        }else if(name == 'date'){
            item.date = values
        }else if(name == 'totalPrice'){
            item.totalPrice = values.target.value ? parseFloat(values.target.value.replace(/,/g, "")) : ''
        }

        dataSourceitems[arrayId] = item;

        this.setState({
            dataTalbeUploads:dataSourceitems
        },() => {
            this.setSummary()
			// this.cllBackSetValueContactNumber()
        })
    }

    destroyWDSlip = async (wdSlipId, arrayId) =>{
        const { form, afterSubmit, client } = this.props
        console.log('wdSlipId',wdSlipId)
        try {
            const { data, errors } = await client.mutate({
                mutation: Mutations.destroyWDSlip,
                variables: {
                    wdSlipId
                }
            })

            if(data){
                alertMessage("success","ส่งเพื่อดำเนินการเรียบร้อย")
                // message.success("ส่งเพื่อดำเนินการเรียบร้อย")
                await this.destroyArrayDataUploads(arrayId)
                // setTimeout(() => {
                //     window.location.reload();
                // }, 600);
            }
        }catch (error) {
            
        }
    }

    destroyArrayDataUploads =  async (arrayId) =>{
        const { dataTalbeUploads } = this.state
        var arrayDataSource = [...this.state.dataTalbeUploads];
		arrayDataSource.splice(arrayId, 1);

		await this.setState({
			dataTalbeUploads:arrayDataSource,
            // dataTalbeLength: lengthData
		},async() => {
            let lengthData = arrayDataSource.length;
            await this.setState({
                dataTalbeLength: lengthData
            })

            await this.setSummary()

            arrayDataSource.map(async (valuesTable, keysTable) =>{
                console.log('valuesTable.date,',valuesTable)
                let valuesDate = valuesTable.date
                let slipNo = `slipNo${keysTable}`
                let numberSlip = `numberSlip${keysTable}`
                let dateTable = `dateTable${keysTable}`
                let totalPriceTable = `totalPrice${keysTable}`

                if(valuesTable.wdSlipId){
                    valuesDate = moment(valuesTable.date)
                }

                await this.props.form.setFieldsValue({
                    [slipNo]: valuesTable.slipNo,
                    [numberSlip]: valuesTable.numberSlip,
                    [dateTable]: valuesDate,
                    [totalPriceTable]: valuesTable.totalPrice,
                })
            })
			// this.cllBackSetValueContactNumber()
		})
    }

    showDataInputUploads = async () =>{
        const { dataTalbeUploads } = this.state
        const rows = {
            wdSlipId:null,
            slipNo: null,
            numberSlip:null,
            date:null,
            totalPrice:null,
            file:null,
        }
        await this.setState(prevState => ({
            dataTalbeUploads: [...prevState.dataTalbeUploads, rows],
        }), async () => {
            let lengthData = dataTalbeUploads.length+1;
            await this.setState({
                dataTalbeLength: lengthData
            })
        })
    }

    handleAdd = async (images, arrayId ) => {
        const { dataTalbeUploads } = this.state
        if(images){
            let dataSourceitems = [...this.state.dataTalbeUploads];
            let item = {...dataTalbeUploads[arrayId]};

            item.file.push(...images)

            item = {
                wdSlipId:null,
                slipNo: item.slipNo,
                numberSlip:item.numberSlip,
                date:item.date,
                totalPrice:item.totalPrice,
                file:item.file,
            }
            dataSourceitems[arrayId] = item;

            await this.setState(({
                dataTalbeUploads: dataSourceitems,
            }), () => {
                this.setSummary()
                // this.cllBackSetValueOrganizatuions()
            })
        }
	}

    hideModalConfirm = async () =>{
        await this.setState({
            ModalConfirmFormTitle:null,
            ModalConfirmFormSubTitle:null,
            ModalConfirmFormShowModal:false,
            ModalConfirmFormBtnOk:null,
            ModalConfirmFormBtnCancel:null,
            ModalConfirmFormValue:null,
            ModalConfirmFormStatus:null,
            preLoadOnsubmit: false,
        })
    }

    showModalFormConfirm = async (e, status) =>{
        const { form, client } = this.props
        
        this.setState({
            preLoadOnsubmit: true
        })

        e.preventDefault()
		form.validateFields(async (err, values) => {
            if (!err) {
                if(status == 'DRAFT'){
                    await this.setState({
                        ModalConfirmFormStatus:status
                    })
                    await this.sendToUpdateWDHospital(values)
                }else{
                    await this.setState({
                        ModalConfirmFormTitle:'ยืนยันการทำรายการขอเบิกค่ารักษาพยาบาล',
                        ModalConfirmFormSubTitle:'',
                        ModalConfirmFormShowModal:true,
                        ModalConfirmFormBtnOk:'ทำเรื่องเบิก',
                        ModalConfirmFormBtnCancel:'ยกเลิก',
                        ModalConfirmFormValue:values,
                        ModalConfirmFormStatus:status
                    })
                }
               
			}else{
                this.setState({
                    preLoadOnsubmit: false
                })
            }
		})
    }

    sendToUpdateWDHospital = async (values , status) => {
        const { form, client } = this.props
        const { 
            dropdownApproverMedical, 
            dataTalbeUploads, 
            detailProfile, 
            withdrawFirstName, 
            withdrawLastName, 
            summaryTotalTable,
            summaryTotal,
            detailForm,
            withdrawIdCard,
            ageValue,
            relationValue,
            dataTalbeUploadsDocument,
            ModalConfirmFormStatus
        } = this.state
        
        this.setState({
            // preLoadOnsubmit: true
        })

        try {

            let approvers = []
            let dataSlip = []
            let checkModal = false
            let attachFiles = []
            let dataAttachFiles = []
            let checkModalAttachFiles = false

            dataTalbeUploads.filter(valuesData => valuesData.wdSlipId == null).map(dataUploads => {
                delete dataUploads.wdSlipId
                dataSlip.push(dataUploads)
            })

            if(dataSlip.length !== 0){
                dataSlip.map((valuesFile , keyValuesFile) =>{
                    dataSlip[keyValuesFile].slipNo = valuesFile.slipNo.trim()
                    dataSlip[keyValuesFile].numberSlip = valuesFile.numberSlip.trim()
                    if(!valuesFile.file){
                        checkModal = true
                    }
                })
            }

            dataTalbeUploadsDocument.filter(valuesData => valuesData.wdHospitalDocumentId == null).map(dataUploadsDocument => {
                delete dataUploadsDocument.wdHospitalDocumentId
                dataAttachFiles.push(dataUploadsDocument)
            })
            

            if(dataAttachFiles.length !== 0){
                dataAttachFiles.map((valuesFile , keyValuesFile) =>{
                    if(valuesFile.documentType == 'อื่น ๆ'){
                        if(!valuesFile.description || !valuesFile.attachFile ){
                            checkModalAttachFiles = true
                        }
                    }else if(valuesFile.documentType){
                        if(!valuesFile.attachFile){
                            checkModalAttachFiles = true
                        }
                    }else if(valuesFile.attachFile){
                        if(!valuesFile.documentType){
                            checkModalAttachFiles = true
                        }
                    }

                    if(valuesFile.documentType || valuesFile.description || valuesFile.attachFile){
                        let dataArray = {
                            documentType: valuesFile.documentType ? valuesFile.documentType : '',
                            description: valuesFile.description ? valuesFile.description : '',
                            file: valuesFile.attachFile,
                        }

                        attachFiles.push(dataArray)
                    }
                })
            }

            if(checkModal){
                Modal.error({
                    title: 'กรุณาอัปโหลดรูปภาพหรือไฟล์',
                    className:'custom-modal-error',
                    okText: 'ตกลง',
                });

                await this.hideModalConfirm()
            }else if(checkModalAttachFiles){
                Modal.error({
                    title: 'กรุณาอัพไฟล์เอกสารแนบอื่นๆหรือ',
                    className:'custom-modal-error',
                    okText: 'ตกลง',
                });
                await this.hideModalConfirm()
            }else{
                const { data, errors } = await client.mutate({
                    mutation: Mutations.updateWDHospital,
                    variables: {
                        wdHospitalId: detailForm.wdHospitalId,
                        empFirstName: detailProfile.firstName,
                        empLastName: detailProfile.lastName,
                        withdrawFirstName: detailForm.withdrawFirstName,
                        withdrawLastName:  detailForm.withdrawLastName,
                        withdrawIdCard: detailForm.withdrawIdCard,
                        relation: values.relation,
                        age: values.age,
                        department: detailProfile.agencyName,
                        division: detailProfile.divisionName,
                        totalWithdraw: summaryTotal,
                        date: values.date,
                        status: ModalConfirmFormStatus,
                        hospitalName: values.hospitalName,
                        hospitalType: values.hospitalType,
                        sicknessName: values.sicknessName,
                        patientType: values.patientType,
                        privateCase: values.privateCase,
                        note: values.note,
                        slip:dataSlip,
                        // approvers,
                        document:attachFiles,
                        empAffiliationOrgCode: detailProfile.empAffiliationOrgCode,
                        isPension: detailProfile.isPension ? detailProfile.isPension : false,
                        // subDeptCode: detailProfile.subDeptCode,
                        // subDeptName: detailProfile.subDeptName,
                        // childSubDeptCode: detailProfile.childSubDeptCode,
                        // childSubDeptName: detailProfile.childSubDeptName,
                    }
                })
                if(data){
                    if(ModalConfirmFormStatus == 'DRAFT'){
                        alertMessage("success","บันทึกร่างสำเร็จ")
                        // message.success("บันทึกร่างสำเร็จ")
                    }else{
                        alertMessage("success","ส่งเพื่อดำเนินการเรียบร้อย")
                        // message.success("ส่งเพื่อดำเนินการเรียบร้อย")
                    }
                    await this.setState({
                        preLoadOnsubmit: false
                    })
                    await this.fetchListWDHospital()
                    await this.hideModalConfirm()
                }
            }
        }catch (error) {
            this.setState({
                preLoadOnsubmit: false
            })
            console.log('error',error)
        }

        // totalWithdraw = summaryTotalTable
    }
    
    handleSubmit = async (e) => {
        this.showModalFormConfirm(e, 'PENDING')
    }

    handleSubmitDraft = async (e) => {
        this.showModalFormConfirm(e, 'DRAFT')
    }

    handleSubmitCancel = async (e) => {
        window.location.href = '/hospital/search/'
    }

    onChangeCheckMoney = async (e) =>{

        await this.setState(({
            checkMoney:e
        }), async() => {
            await this.resestFieldValueTableSlip()
            await this.setSummary()
            await this.setSummarySlipWithdraw()
            // this.cllBackSetValueOrganizatuions()
        })

        // console.log(e)
    }

    resestFieldValueTableSlip = async () =>{
        const { dataTalbeUploads, checkMoney } = this.state

        dataTalbeUploads.map(async (valuesFile , keyValues) =>{
            let totalSet = null
            if(checkMoney == 'ฉุกเฉินเร่งด่วน' || checkMoney == 'ฉุกเฉิน ไม่รุนแรง' ){
                totalSet = valuesFile.totalPrice / 2
                dataTalbeUploads[keyValues].totalSlipWithdraw = totalSet
            }else{
                totalSet = valuesFile.totalPrice
                dataTalbeUploads[keyValues].totalSlipWithdraw = totalSet
            }
            
            let totalFormValue = null
            if(parseFloat(totalSet.toString().replace(/,/g, ""))){
                if(!totalSet.toString().includes('.')){
                    totalFormValue = totalSet.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'.00'
                }else{
                    if(totalSet.toString().includes('.')){
                        totalFormValue = totalSet.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }else{
                        totalFormValue = totalSet.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'.00'
                    }
                }
            }else{
                dataTalbeUploads[keyValues].totalSlipWithdraw = 0
                totalFormValue = null
            }

            if(totalFormValue == 0 || totalFormValue == null){
                totalFormValue = null
            }else{
                totalFormValue = totalFormValue
            }

            let totalSlipWithdraw = `totalSlipWithdraw${keyValues}`
           
            await this.props.form.setFieldsValue({
                [totalSlipWithdraw]: totalFormValue
            })
        })
    }

    onClickToNewTab = (typeFile) =>{
        const { linkNewTab } = this.state
        if(typeFile !== "application/pdf"){
            var win = window.open();
            win.document.write('<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="' + linkNewTab  + '" style="height:100%"/></div>');
        }else{
            var win = window.open();
            win.document.write('<iframe src="' + linkNewTab  + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
        }
    }

    modalShowFileCreate = async (dataFile, title) =>{
        var url = URL.createObjectURL(dataFile)
        const reader = new FileReader();
        if( dataFile.type !== "application/pdf"){
            reader.readAsDataURL(dataFile)
            reader.onloadend = async (e) => {
                var dataURL = reader.result;
                await this.setState({
                    linkNewTab: dataURL
                })
            };
        }else{
            reader.readAsDataURL(dataFile)
            reader.onloadend = async (e) => {
                var dataURL = reader.result;
                // var output = document.getElementById('show-pdf-popup');
                // output.href = dataURL;
                await this.setState({
                    linkNewTab: dataURL
                })
            };
        }

        Modal.info({
            className:"modalFickIcons",
            title: title,
            width:"800px",
            content: (
                <div className="mt-4">
                    {
                        dataFile.type == "application/pdf" ?
                            <a id="show-pdf-popup"  onClick={()=>this.onClickToNewTab(dataFile.type)} className="color-red" style={{ textDecoration: "underline" }}>
                                คลิกเพื่อดูเอกสาร
                            </a>
                        :
                            <a id="show-images-popup" onClick={()=>this.onClickToNewTab(dataFile.type)} className="color-red mt-5" style={{ textDecoration: "underline" }}>
                                คลิกเพื่อดูรูปภาพ
                            </a>
                    }
                </div>
            ),
            okText: 'ปิด',
            onOk() {},
        });
    }

    onChangeCheckNameWithdraw = (values) =>{
        const { listFamily } = this.state
        let dataPersion = []

        listFamily.map((valuesPersion)=>{
            if(valuesPersion.identitycard == values){
                dataPersion = valuesPersion
            }
        })

        this.setState({
            relationValue: dataPersion.relationShipLabel,
            ageValue: dataPersion.age ? dataPersion.age : null,
            withdrawFirstName: dataPersion.firstName,
            withdrawLastName: dataPersion.lastName,
            withdrawIdCard: dataPersion.identitycard
        })

        this.props.form.setFieldsValue({
            relation: dataPersion.relationShipLabel,
            age: parseFloat(0),
        })
    }

    onChangeHospitalDetail = async(hospitalId) =>{
        const { client, location, match } = this.props
        const { posId } = this.state
        console.log(hospitalId)
        const { data, errors } = await client.query({
            query: Queries.fetchHospital,
            variables:{
                hospitalId
            }
        })

        // console.log('data.fetchHospital',data)

        if(data.fetchHospital){
           this.props.form.setFieldsValue({
                hospitalType: data.fetchHospital.affiliation,
                privateCase:""
            })

            await this.setState({
                hospitalDetailValue: data.fetchHospital.affiliation,
            })
            await this.setSummary()
        }
    }

    dropdownListHospital = async() =>{
        const { client, location, match } = this.props
        const { posId } = this.state
        const { data, errors } = await client.query({
            query: Queries.dropdownListHospital,
        })

        if(data.dropdownListHospital){
            await this.setState({
                dropdownHospital: data.dropdownListHospital
            })
        }
    }

    dropdownListSickness = async() =>{
        const { client, location, match } = this.props
        const { posId } = this.state
        const { data, errors } = await client.query({
            query: Queries.dropdownListSickness,
        })

        console.log('data',data)

        if(data.dropdownListSickness){
            await this.setState({
                dropdownSickness: data.dropdownListSickness
            })
        }
    }

    hideModal = async()=>{
        await this.setState({
            visibleModal: false
        })
    }

    modalShowFile = async (dataFile, title) =>{
        // console.log('dataFile.fileMimeType',dataFile)
        Modal.info({
            className:"modalFickIcons",
            title: title,
            width:"800px",
            content: (
              <div >
                  {
                    dataFile.fileMimeType == 'application/pdf' ?
                        <IframeFile typeFile={dataFile.fileMimeType}  file={dataFile.fileId}/>
                    :
                        <ImageFileNewtab typeFile={dataFile.fileMimeType}  file={dataFile.fileId}/>
                  }
              </div>
            ),
            okText: 'ปิด',
            onOk() {},
            // closable:({disabled:false})
        });
    }

    fetchListWDHospital = async()=>{
		const { client,location ,match } = this.props
        const { offset ,limit, disabledDateStart, endDate } = this.state

        await this.setState({
            preLoadSubmit:true
        })

        const { data, errors } = await client.query({
            query: Queries.fetchListWDHospital,
			variables: {
                wdHospitalId:match.url.split('/')[3],
                searchType: 'DETAIL'
			}
        })


        // let objectSummary = {
        //     rowSummary: 'Summary',
        // }

        // dataTalbeUploads.push(objectSummary)
        console.log('fetchListWDHospitalfetchListWDHospital',data.fetchListWDHospital)

		if(data.fetchListWDHospital.length !== 0){
            let dataTalbeUploads = data.fetchListWDHospital[0].slip
			await this.setState({
                dataTableMedicalCertificate: data.fetchListWDHospital[0].medCert,
				dataTalbeUploads,
                dataTalbeLength: data.fetchListWDHospital[0].slip.length,
                detailForm: data.fetchListWDHospital[0],
                hospitalDetailValue: data.fetchListWDHospital[0].hospitalType,
                summaryTotal: data.fetchListWDHospital[0].totalWithdraw,
                checkMoney: data.fetchListWDHospital[0].privateCase,
                dataTalbeUploadsDocument: data.fetchListWDHospital[0].documentMultiFile.length !== 0 ? data.fetchListWDHospital[0].documentMultiFile : [],
                dataTalbeLengthDocument: data.fetchListWDHospital[0].documentMultiFile.length !== 0 ? data.fetchListWDHospital[0].documentMultiFile.length : [],
                patientType: data.fetchListWDHospital[0].patientType
                // summaryTotalTableSlipWithdraw: data.fetchListWDHospital[0].totalCurrentWithdraw
			})
		}else{
            // message.error('คุณไม่มีสิทธิ์ในการเข้าดูเอกสารนี้');
            alertMessage("error","คุณไม่มีสิทธิ์ในการเข้าดูเอกสารนี้")
            setTimeout(() => {
                window.location.href = '/hospital/search/'
            }, 3000);
        }
	}

    fetchWDHospitalHistory = async () =>{
        const { client, location, match } = this.props
        const { posId } = this.state
        
        const { data, errors } = await client.query({
            query: Queries.fetchWDHospitalHistory,
            variables: {
                wdHospitalId:match.url.split('/')[3]
			}
        })
        if(data.fetchWDHospitalHistory){
            await this.setState({
                dataTalbePeople: data.fetchWDHospitalHistory,
            })
        }
    }

    setSummary = async () =>{
        const { dataTalbeUploads, checkMoney } = this.state

        let total = setSummaryTotal(dataTalbeUploads, checkMoney)

        await this.setState({
            summaryTotal: total['totalMoney'],
            summaryTotalTable: total['summaryTotalTable']
        })
    }

    setSummarySlipWithdraw = async (fetchDisMonth = false) =>{
        const { dataTalbeUploads, checkMoney, hospitalDetailValue } = this.state

        let total = setSummarySlipWithdrawTotal(dataTalbeUploads, checkMoney, hospitalDetailValue)

        if(fetchDisMonth){
            await this.setState({
                summaryTotalTableSlipWithdraw: total['summaryTotalTable']
            })
        }else{
            await this.setState({
                summaryTotalSlipWithdraw: total['totalMoney'],
                summaryTotalTableSlipWithdraw: total['summaryTotalTable']
            })
        }
    }

	async componentDidMount(){
        await this.dropdownListHospital()
        await this.dropdownListSickness()
        // await this.fetchApproverMedical()
        await this.fetchProfile()
        await this.fetchMedicalExpensesLicensee()
        await this.dropdownMedicalExpensesLicensee()
        await this.fetchListWDHospital()
        await this.fetchWDHospitalHistory()
		await this.setSummary()
        await this.setSummarySlipWithdraw()
    }

	render() {
		const { match } = this.props
        const { getFieldDecorator } = this.props.form
        const { 
            columns, 
            preLoadOnsubmit, 
            dataTalbeUploads, 
            summaryTotal, 
            summaryTotalTable,
            dropdownApproverMedical,
            detailProfile,
            dropdownFamily,
            dropdownHospital,
            dropdownSickness,
            hospitalDetailValue,
            detailForm,
            visibleModal,
            modalFileMimeType,
            modalFileId,
            dataTalbePeople,
            dataTalbeUploadsDocument,
            columnsDocument,
            columnsSummary,
            ModalConfirmFormTitle,
            ModalConfirmFormSubTitle,
            ModalConfirmFormShowModal,
            ModalConfirmFormBtnOk,
            ModalConfirmFormBtnCancel,
            ModalConfirmFormValue,
            ModalshowAllImageVisible,
            ModalshowAllImageTitle,
            ModalshowAllImageData,
            ModalshowAllImageArrayId,
            ModalshowAllImageDatabase,
            dataTableMedicalCertificate,
            patientType,
            checkMoney
        } = this.state

        console.log('detailForm',detailForm)
        
		return (
            <>
                <Container match={match}>
                    <div className="breadcrumb-custom pb-3 mb-5">
                        {/* <Breadcrumb.Item> */}
                            <span style={{ fontSize:"18px" }}>รายการเบิกทั้งหมด / ดูรายการเบิก </span>
                        {/* </Breadcrumb.Item> */}
                    </div>
                    <ModalConfirmForm 
                        title={ModalConfirmFormTitle} 
                        subtitle={ModalConfirmFormSubTitle}
                        showModal={ModalConfirmFormShowModal} 
                        btnOk={ModalConfirmFormBtnOk} 
                        btnCancel={ModalConfirmFormBtnCancel}  
                        submitToSend={ this.sendToUpdateWDHospital }
                        hideModal={ this.hideModalConfirm }
                        valueConfirm = { ModalConfirmFormValue }
                    />
                    
                    <ModalshowAllImage
                        title={ModalshowAllImageTitle} 
                        showModal={ModalshowAllImageVisible}
                        data={ModalshowAllImageData}
                        hideModal={ this.ModalshowAllImageHide }
                        dataArrayId={ ModalshowAllImageArrayId }
                        destroyArrayDataImages = { this.destroyArrayDataImages }
                        imageDatabase = {ModalshowAllImageDatabase}
                    />

                    <div className="card-container h-100" id="page-profile">
                        {
                            detailForm.length !== 0 ?  
                                <>
                                    <Form ref={this.formRef} className="custom-form-magin">
                                        <div className="px-5 py-1 card-bg-green">
                                            <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                                                <Col xs={24} md={24} className="pt-2 mb-3">
                                                    <strong className="color-red">
                                                        ข้อมูลเอกสาร
                                                    </strong>
                                                </Col>

                                                <Col xs={24} md={12} className="pt-2 mb-1">
                                                    <FromInput disabled={true} value={detailForm ? detailForm.refDocument : ''} required={false} name={"refDocument"} label="เลขที่สารบรรณ" mode={"text"} />
                                                    {/* <Form.Item label={"เลขที่สารบรรณ"} className="mb-0">
                                                        { getFieldDecorator('refDocument', {
                                                            initialValue: detailForm.refDocument,
                                                            rules:  [{ 
                                                                required: true, 
                                                                message: 'กรุณาระบุ เลขที่สารบรรณ',
                                                            }],
                                                        })(
                                                            <TextArea
                                                                rows={1} 
                                                                className='block-news' 
                                                                maxLength={50}
                                                                disabled={ true }
                                                            />
                                                        )}
                                                    </Form.Item> */}
                                                </Col>

                                                <Col xs={24} md={12} className="pt-2 mb-1">
                                                    <FromInput disabled={true} value={detailForm ? detailForm.withdrawNo : ''} required={false} name={"ผผผผผ"} label="เลขที่เอกสาร" mode={"text"} />
                                                </Col>
                                               

                                                <Col xs={24} md={12} className="pt-2 mb-1">
                                                    <FromInput disabled={true} value={detailForm ? checkStatus(detailForm.status) : ''} required={false} name={"ผผผผผ"} label="สถานะเอกสาร" mode={"text"} />
                                                </Col>

                                                <Col xs={24} md={12} className="pt-2 mb-1">
                                                    <FromInput disabled={true} value={detailForm ? detailForm.createdBy : ''} required={false} name={"ผผผผผ"} label="ผู้สร้างเอกสาร" mode={"text"} />
                                                </Col>
                                                <Col xs={24} md={12} className="pt-2 mb-1">
                                                    <Form.Item label={'วันที่สร้างเอกสาร'} className="mb-0">
                                                        { getFieldDecorator('createdAt', {
                                                            initialValue: moment(detailForm.createdAt),
                                                            rules:  [{ 
                                                                // required:true, 
                                                                message: 'กรุณากรอกหรือเลือก วันที่สร้างเอกสาร',
                                                            }],
                                                        })(
                                                            <DatePicker 
                                                                format={this.dateFormatNumber("createdAt")} 
                                                                placeholder="" 
                                                                style={{ width:"100%" }} 
                                                                disabled={ true }
                                                            />
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            {/* </div> */}
                                            {/* <div className="px-5 py-1 card-bg-green"> */}
                                                <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                                                    <Col xs={24} md={24} className="pt-2 mb-3">
                                                        <strong className="color-red">
                                                            ข้อมูลบุคลากร
                                                        </strong>
                                                    </Col>

                                                    <Col xs={24} md={12} className="pt-2 mb-1">
                                                        <FromInput disabled={true} value={detailProfile ? detailProfile.name : ""} required={false} name={"name"} label="ชื่อบุคลากร" mode={"text"} />
                                                    </Col>

                                                    <Col xs={24} md={12} className="pt-2 mb-1">
                                                        {/* <FromInput value={null} required={false} name={"code"} label="ชื่อผู้เบิก" mode={"text"} /> */}
                                                        <Form.Item label={"ชื่อผู้เบิก"}>
                                                            { getFieldDecorator("checkNameWithdraw", {
                                                                initialValue: detailForm.withdrawFirstName+' '+detailForm.withdrawLastName,
                                                                rules:  [{ 
                                                                    required:false, 
                                                                    message: 'กรุณาระบุ ชื่อผู้เบิก',
                                                                }],
                                                            })(
                                                                <Input 
                                                                    className='block-news' 
                                                                    disabled={true}
                                                                />
                                                            )}
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} md={12} className="pt-2 mb-1">
                                                        <FromInput disabled={true} value={detailForm ? detailForm.empTypeLabel : ""} required={false} name={"empTypeLabel"} label="ประเภทบุคลากร" mode={"text"} />
                                                    </Col>
                                                    <Col xs={24} md={12} className="pt-2 mb-1">
                                                        {/* <FromInput value={relationValue} disabled={true} required={false} name={"relation"} label="ความสัมพันธ์" mode={"text"} /> */}
                                                        <Form.Item label={"ความสัมพันธ์"}>
                                                            { getFieldDecorator("relation", {
                                                                initialValue: detailForm.relation,
                                                                rules:  [{ 
                                                                    required:false, 
                                                                    message: 'กรุณาระบุ ชื่อผู้เบิก',
                                                                }],
                                                            })(
                                                                <Input 
                                                                    className='block-news' 
                                                                    disabled={true}
                                                                />
                                                            )}
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} md={12} className="pt-2 mb-1">
                                                        {/* <FromInput value={ageValue} disabled={true}  required={false} name={"age"} label="อายุ" mode={"text"} /> */}
                                                        <Form.Item label={"อายุ"}>
                                                            { getFieldDecorator("age", {
                                                                initialValue: detailForm.age,
                                                                rules:  [{ 
                                                                    required:false, 
                                                                    message: 'กรุณากรอกหรือเลือก อายุ',
                                                                }],
                                                            })(
                                                                <Input 
                                                                    className='block-news' 
                                                                    disabled={true}
                                                                />
                                                            )}
                                                        </Form.Item>
                                                    </Col>

                                                    <Col span={12}  className="pt-2">
                                                        <FromInput disabled={true} value={detailForm ? detailForm.workingStatus : ''} required={false} name={"workingStatus"} label="สถานภาพ" mode={"text"} />
                                                    </Col>
                                                    <Col span={12}  className="pt-2">
                                                        <FromInput disabled={true} value={detailForm.resignationDate ? changeFormatdate(detailForm.resignationDate) : '-'} required={false} name={"resignationDate"} label="วันที่พ้นสภาพ" mode={"text"} />
                                                    </Col>
                                                </Row>
                                            {/* </div> */}

                                            {/* <div className="px-5 py-1 card-bg-green"> */}
                                                <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                                                    <Col xs={24} md={24} className="pt-2 mb-3">
                                                        <strong className="color-red">
                                                            รายการ
                                                        </strong>
                                                    </Col>

                                                    <Col xs={24} md={12} className="pt-2 mb-1">
                                                        <Form.Item label={'วันที่ยื่นเรื่อง'} className="mb-0">
                                                            { getFieldDecorator('date', {
                                                                initialValue: moment(detailForm.date),
                                                                rules:  [{ 
                                                                    required:true, 
                                                                    message: 'กรุณากรอกหรือเลือก วันที่ยื่นเรื่อง',
                                                                }],
                                                            })(
                                                                <DatePicker 
                                                                    format={this.dateFormatNumber("date")} 
                                                                    placeholder="" 
                                                                    style={{ width:"100%" }} 
                                                                    disabled={ true }
                                                                />
                                                            )}
                                                        </Form.Item>
                                                    </Col>

                                                    <Col xs={24} md={12} className="pt-2 mb-1">
                                                        <Form.Item label={'วันที่จ่ายเงิน'} className="mb-0">
                                                            <Input 
                                                                value={ detailForm.exportPayDate ? changeFormatdate(detailForm.exportPayDate) : '-' }
                                                                className='block-news' 
                                                                disabled={true}
                                                            />
                                                        </Form.Item>
                                                    </Col>

                                                    <Col xs={24} md={12} className="pt-2 mb-">
                                                        <Form.Item label={"ประเภทการจ่ายเงิน"} className="mb-0">
                                                            { getFieldDecorator("isJuristic", {
                                                                initialValue: detailForm.isJuristic,
                                                            })(
                                                                <Radio.Group  
                                                                    disabled={true}
                                                                >
                                                                    <Radio value={false}>จ่ายให้บุคลากร</Radio>
                                                                    <Radio value={true}>จ่ายให้นิติบุคคล (โรงพยาบาล)</Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Form.Item>
                                                    </Col>

                                                    <Col xs={24} md={12} className="pt-2 mb-1">
                                                        <Form.Item label={"ช่องทางการจ่ายเงิน"} className="mb-0">
                                                            { getFieldDecorator("cashFlg", {
                                                                initialValue: detailForm.cashFlg,
                                                            })(
                                                                <Radio.Group  
                                                                    disabled={true}
                                                                >
                                                                    <Radio value={"โอนเงิน"}>โอนเงิน</Radio>
                                                                    <Radio value={"รับเงินสด"}>รับเงินสด</Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Form.Item>
                                                    </Col>

                                                    <Col xs={24} md={12} className="pt-2 mb-1">
                                                        <Form.Item label={"ชื่อสถานพยาบาล"}>
                                                            { getFieldDecorator("hospitalName", {
                                                                initialValue: detailForm.hospitalDetail,
                                                                rules:  [{ 
                                                                    required: true, 
                                                                    message: 'กรุณาระบุ ชื่อสถานพยาบาล',
                                                                }],
                                                            })(
                                                                <Select 
                                                                    style={{ width: "100%" }}
                                                                    onChange={ (e) => this.onChangeHospitalDetail(e) }
                                                                    // disabled={ checkDisbledInput(detailForm.status, "hospitalName") ? true : false }
                                                                    disabled={true}
                                                                    // defaultValue={'123123'}
                                                                >
                                                                    {
                                                                        dropdownHospital.length !== 0 ? 
                                                                            dropdownHospital.map((valuseLabel, keysLabel) =>{
                                                                                return <Option value={valuseLabel.id}>{ valuseLabel.label }</Option>
                                                                            })
                                                                        : ''
                                                                    }
                                                                </Select>
                                                            )}
                                                        </Form.Item>
                                                    </Col>

                                                    {/* <Col xs={24} md={12} className="pt-2 mb-1">
                                                        <Form.Item label={"ชื่อสถานพยาบาล"}>
                                                            { getFieldDecorator("hospitalName", {
                                                                initialValue: detailForm.hospitalName,
                                                                rules:  [{ 
                                                                    required: true, 
                                                                    message: 'กรุณาระบุ ชื่อสถานพยาบาล',
                                                                }],
                                                            })(
                                                                <Select 
                                                                    style={{ width: "100%" }}
                                                                    onChange={ (e) => this.onChangeHospitalDetail(e) }
                                                                    // disabled={ checkDisbledInput(detailForm.status, "hospitalName") ? true : false }
                                                                    disabled={true}
                                                                    // defaultValue={'123123'}
                                                                >
                                                                    {
                                                                        dropdownHospital.length !== 0 ? 
                                                                            dropdownHospital.map((valuseLabel, keysLabel) =>{
                                                                                return <Option value={valuseLabel.id}>{ valuseLabel.label }</Option>
                                                                            })
                                                                        : ''
                                                                    }
                                                                </Select>
                                                            )}
                                                        </Form.Item>
                                                    </Col> */}

                                                    {
                                                        detailForm.isJuristic &&
                                                        <Col xs={24} md={12} className="pt-2 mb-1">
                                                            <Form.Item label={"ธนาคาร"}>
                                                                <Input 
                                                                    value={ detailForm.hospitalBankDetail }
                                                                    className='block-news' 
                                                                    disabled={true}
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    }

                                                    <Col xs={24} md={12} className="pt-2 mb-1">
                                                        <Form.Item label={"ประเภทสถานพยาบาล"}>
                                                            { getFieldDecorator("hospitalType", {
                                                                initialValue: detailForm.hospitalType,
                                                                rules:  [{ 
                                                                    required:false, 
                                                                }],
                                                            })(
                                                                <Input 
                                                                    className='block-news' 
                                                                    disabled={true}
                                                                />
                                                            )}
                                                        </Form.Item>
                                                    </Col>

                                                    <Col xs={24} md={12} className="pt-2 mb-1">
                                                        <Form.Item label={"ประเภทผู้ป่วย"}>
                                                            { getFieldDecorator("patientType", {
                                                                initialValue: detailForm.patientType,
                                                                rules:  [{ 
                                                                    required: true, 
                                                                    message: 'กรุณาระบุ ประเภทผู้ป่วย',
                                                                }],
                                                            })(
                                                                <Select 
                                                                    style={{ width: "100%" }} 
                                                                    // disabled={ checkDisbledInput(detailForm.status, "patientType") ? true : false }
                                                                    disabled={true}
                                                                >
                                                                    <Option value="ผู้ป่วยนอก">ผู้ป่วยนอก</Option>
                                                                    <Option value="ผู้ป่วยใน">ผู้ป่วยใน</Option>
                                                                </Select>
                                                            )}
                                                        </Form.Item>
                                                    </Col>

                                                    <Col span={12} className="pt-2 mb-1">
                                                        <Form.Item label={"จ่ายในงบ"}>
                                                            <Input 
                                                                value={ detailForm.coaCodeName }
                                                                className='block-news' 
                                                                disabled={true}
                                                            />
                                                        </Form.Item>
                                                    </Col>

                                                    <Col xs={24} md={12} className="pt-2 mb-1">
                                                        <Form.Item label={"ป่วยเป็นโรค"}>
                                                            { getFieldDecorator("sicknessName", {
                                                                initialValue: detailForm.sicknessName,
                                                                rules:  [{ 
                                                                    required: true, 
                                                                    message: 'กรุณาระบุุ ป่วยเป็นโรค',
                                                                }],
                                                            })(
                                                                <Select 
                                                                    style={{ width: "100%" }}
                                                                    // disabled={ checkDisbledInput(detailForm.status, "sicknessName") ? true : false }
                                                                    disabled={true}
                                                                >
                                                                    {
                                                                        dropdownSickness.length !== 0 ? 
                                                                            dropdownSickness.map((valuseLabel, keysLabel) =>{
                                                                                return <Option value={valuseLabel.id}>{ valuseLabel.label }</Option>
                                                                            })
                                                                        : ''
                                                                    }
                                                                </Select>
                                                            )}
                                                        </Form.Item>
                                                    </Col>

                                                    <Col xs={24} md={24} ></Col>
                                                    {
                                                        patientType == 'ผู้ป่วยใน' &&
                                                        <>
                                                            {/* {
                                                                detailForm.isJuristic &&
                                                                <Col xs={24} md={12} className="pt-2 mb-1"></Col>
                                                            } */}
                                                            <Col xs={ 24 } md={12} className="pt-2 mb-0">
                                                                <Form.Item label="วันที่เข้าโรงพยาบาล">
                                                                    { getFieldDecorator('treatmentStartDate', {
                                                                        initialValue: moment(detailForm.treatmentStartDate),
                                                                        rules:  [{ 
                                                                            required: true, 
                                                                            message: 'กรุณากรอกหรือเลือก วันที่เข้าโรงพยาบาล',
                                                                        }],
                                                                    })(
                                                                        <DatePicker 
                                                                            format={this.dateFormatNumber("treatmentStartDate")} 
                                                                            className="w-100"  
                                                                            placeholder="เลือกวันที่" 
                                                                            disabledDate={true}
                                                                            disabled={true}
                                                                        />
                                                                    )}
                                                                </Form.Item>
                                                            </Col>
                                                            
                                                            <Col xs={ 24 } md={12}  className="pt-2 mb-0">
                                                                <Form.Item label="วันที่ออกจากโรงพยาบาล" >
                                                                    { getFieldDecorator('treatmentEndDate', {
                                                                        initialValue:  moment(detailForm.treatmentEndDate),
                                                                        rules:  [{ 
                                                                            required:true,
                                                                            message: 'กรุณากรอกหรือเลือก วันที่ออกจากโรงพยาบาล',
                                                                        }],
                                                                    })(
                                                                        <DatePicker 
                                                                            format={this.dateFormatNumber("treatmentEndDate")} 
                                                                            className="w-100"  
                                                                            placeholder="เลือกวันที่" 
                                                                            disabledDate={true}
                                                                            disabled={true}
                                                                        />
                                                                    )}
                                                                </Form.Item>
                                                            </Col>
                                                        </>
                                                    }
                                                    
                                                    {/* <Col xs={24} md={24} className={hospitalDetailValue == 'เอกชน' && hospitalDetailValue ? "pt-2 mb-1" : "pt-2 mb-1 d-none"}>
                                                        <Form.Item label={"กรณีเอกชน"}>
                                                            { getFieldDecorator("privateCase", {
                                                                initialValue: detailForm.privateCase,
                                                                rules:  [{ 
                                                                    required: hospitalDetailValue == 'เอกชน' && hospitalDetailValue ? true : false, 
                                                                    message: 'กรุณากรอกหรือเลือก กรณีเอกชน',
                                                                }],
                                                            })(
                                                                <Radio.Group  
                                                                    onChange={e => this.onChangeCheckMoney(e.target.value)}
                                                                    // disabled={ checkDisbledInput(detailForm.status, "privateCase") ? true : false }
                                                                    disabled={true}
                                                                >
                                                                    <Radio value={"ฉุกเฉิน/วิกฤต"}>ฉุกเฉิน/วิกฤต</Radio>
                                                                    <Radio value={"ฉุกเฉินเร่งด่วน"}>ฉุกเฉินเร่งด่วน</Radio>
                                                                    <Radio value={"ฉุกเฉิน ไม่รุนแรง"}>ฉุกเฉิน ไม่รุนแรง</Radio>
                                                                </Radio.Group>
                                                            )}
                                                        </Form.Item>
                                                    </Col> */}
                                                </Row>
                                            {/* </div> */}

                                            {/* <div className="px-5 py-1 card-bg-green"> */}
                                                <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                                                    <Col xs={24} md={24} className="pt-2 mb-3">
                                                        <strong className="color-red">
                                                            เอกสารแนบใบเสร็จ
                                                        </strong>
                                                    </Col>
                                                    
                                                    <Col xs={24} md={24} align={"right"}>
                                                        <Table
                                                            columns={columns}
                                                            dataSource={dataTalbeUploads}
                                                            pagination={false}
                                                            className="mb-3"
                                                            bordered
                                                            scroll={{ x:"max-content"}}
                                                            // rowCount={dataTalbeUploads.length}
                                                            footer={(pageData) => {
                                                                // return(
                                                                //     <>
                                                                //         <TableSummary summaryTotalTable={summaryTotalTable} summaryTotalSlipWithdraw={detailForm.totalCurrentWithdraw}/>
                                                                //     </>
                                                                // )

                                                            }}
                                                        />
                                                        
                                                        {
                                                            (detailForm.status == 'MOREINFO' || detailForm.status == 'DRAFT' ) &&
                                                                <Button 
                                                                    style={{ display:"inline-block" }}
                                                                    type="primary btn-color-default btn-custom btn-clear color-white" 
                                                                    className="mt-1 mr-2"
                                                                    onClick={ () => this.showDataInputUploads() }
                                                                    // disabled={ checkDisbledInput(detailForm.status, "btnPush") ? true : false }
                                                                    disabled={true}
                                                                >
                                                                    เพิ่ม +
                                                                </Button>
                                                        }
                                                    </Col>

                                                    <Col xs={24} md={12} className="pt-2">
                                                        <Form.Item label={"จำนวนเงินในใบเสร็จ  (บาท)"}> 
                                                            <Input 
                                                                className='block-news mt-2' 
                                                                defaultValue={summaryTotalTable ? numberWithCommas(summaryTotalTable) : ''} 
                                                                value={summaryTotalTable ? numberWithCommas(summaryTotalTable) : ''} 
                                                                disabled={true}
                                                                className="input-number"
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    
                                                    <Col xs={24} md={12}  className="pt-2">
                                                        {/* <b style={{ color:"#000" }}>จำนวนเงินที่เบิกได้ทั้งหมด  (บาท)</b> */}
                                                        <Form.Item label={"จำนวนเงินที่เบิกได้ทั้งหมด  (บาท)"}> 
                                                            <Input 
                                                                value={ numberWithCommas(detailForm.totalCurrentWithdraw) }
                                                                className='block-news' 
                                                                disabled={true}
                                                                className="input-number"
                                                            />
                                                        </Form.Item>
                                                    </Col>

                                                    {
                                                        (hospitalDetailValue == 'เอกชน' && checkMoney == 'ฉุกเฉินเร่งด่วน' || checkMoney == 'ฉุกเฉิน ไม่รุนแรง') &&
                                                        <Col xs={24} md={12} offset={12} className="pt-2 mb-5">
                                                            <p className="color-red mb-0">หมายเหตุ : กรณีฉุกเฉินเร่งด่วน/ไม่รุนแรง  เบิกได้ครึ่งหนึ่งตามใบเสร็จ แต่ไม่เกิน 8,000 บาท</p>
                                                        </Col>
                                                    }
                                                    

                                                    <Col xs={24} md={24} className="pt-2 mb-3">
                                                        <TableMedicalCertificate
                                                            // formCurrent = {this.formRef.current}
                                                            setDataTableMedicalCertificate = {''}
                                                            dataTableMedicalCertificate = {dataTableMedicalCertificate}
                                                            statusForm={true}
                                                        />
                                                    </Col>

                                                    <Col xs={24} md={24} className="pt-2 mb-3">
                                                        <strong className="color-red">
                                                            เอกสารแนบอื่นๆ
                                                        </strong>
                                                    </Col>

                                                    <Col xs={24} md={24} align={"right"}>
                                                        <Table
                                                            locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
                                                            columns={columnsDocument}
                                                            dataSource={dataTalbeUploadsDocument}
                                                            pagination={false}
                                                            className="mb-3"
                                                            bordered
                                                            scroll={{ x:"max-content"}}
                                                            // rowCount={dataTalbeUploadsDocument.length}
                                                            // pagination={{ pageSize: dataTalbeUploadsDocument.length }}
                                                        />
                                                        
                                                        {
                                                            (detailForm.status == 'MOREINFO' || detailForm.status == 'DRAFT' ) &&
                                                                <Button 
                                                                    style={{ display:"inline-block" }}
                                                                    type="primary btn-color-default btn-custom btn-clear color-white" 
                                                                    className="mt-1 mr-2"
                                                                    onClick={ () => this.showDataInputUploadsDocument() }
                                                                    disabled={true}
                                                                >
                                                                    เพิ่ม +
                                                                </Button>
                                                        }
                                                    </Col>

                                                    <Col xs={24} md={24}  className="pt-2">
                                                        <Form.Item label={"หมายเหตุ"}>
                                                            { getFieldDecorator("note", {
                                                                initialValue: detailForm.note,
                                                                rules:  [{ 
                                                                    // required: true, 
                                                                    message: 'กรุณากรอกหรือเลือก ประเภทสถานพยาบาล',
                                                                }],
                                                            })(
                                                                <TextArea
                                                                    rows={3} 
                                                                    className='block-news' 
                                                                    disabled={true}
                                                                />
                                                            )}
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            {/* </div> */}

                                            {/* <div className="px-5 py-1 card-bg-green"> */}
                                                <TalbePeople dataTalbePeople={ dataTalbePeople }/>
                                            {/* </div> */}
                                        </div>
                                        
                                    </Form>
                                </>
                            : 
                                <Row>
                                    <Col align="center" className="mt-5">
                                        <Spin size="large" />
                                    </Col>
                                </Row>
                        }
                    </div>
                </Container>
            </>
		)
	}
}

Withdraw.defaultProps = {
	autoFocus: false
}

Withdraw.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedWithdraw = Form.create()(Withdraw)

export default withApollo(WrappedWithdraw)